// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"reports-module__sectionHeader___2JjWK","headerRow":"reports-module__headerRow___2ECCg","reportRow":"reports-module__reportRow___3wlPn"};